import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { PersonSlash } from '@/ui/icons/person-slash';

export default function AuthorizedDrivers() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">Authorized Drivers Policy</Text>

        <View style={{ gap: 16 }}>
          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Only authorized drivers listed in the rental agreement may operate
            the vehicle. Giving the keys to an unauthorized person will void
            your insurance and make you personally liable for any damage or
            incidents.
          </Text>

          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Need to add more drivers? Contact us to update your reservation —
            your first two additions are free.
          </Text>
        </View>
      </View>

      <View>
        <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <Icon
            type="dressed"
            icon={<PersonSlash />}
            fillColor={theme.colors.icon.color}
            width={25}
            height={25}
          />

          <Text type="bodyBold">No unauthorized drivers</Text>
        </View>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
